import { scope } from 'arktype';
import { configure } from 'arktype/config';

configure({ exactOptionalPropertyTypes: false, onUndeclaredKey: 'delete' });

export const arkScope = scope({
  Side: "'Buy' | 'Sell'",
  PriceType: "'AMOUNT'| 'VOLATILITY'| 'PERCENT'| 'PPS'",
  CurrencyChoice: '1 | 2',
  BidAsk: { bid: 'number', ask: 'number' },
  Frequency:
    "'Daily' | 'EndOfMonth' | 'EndOfMonthValue' | 'EveryDay' | 'Maturity' | 'Monthly' | 'None' | 'Quarterly' | 'SemiAnnually' | 'TwoWeeks' | 'Weekly' | 'Yearly'",

  TargetProfitType: "'ADJUSTED_BY_AMOUNT' | 'ADJUSTED_BY_STRIKE' | 'FULL' | 'NONE'",

  // Options
  MultipassLegId: 'string & /^.+\\/0\\/(\\d+|call|put)$/',
  StrategyType: "'Vanilla' | 'Multileg' | 'Straddle' | 'Strangle' | 'RiskReversal'",
});
